import React from 'react';
import { Accordion as ReactAccordion } from 'react-accessible-accordion';

import { StyledAccordion } from './Accordion.styles';

import { AccordionProps } from './Accordion.types';

import { AccordionItem } from './AccordionItem';

const Accordion = ({
  items,
  onChangeItem,
  preExpandedList = [],
  isAllowedMultipleExpanded = true,
  handleItemRefExpansion = () => {},
  componentClassname = 'accordion',
  customClassnames = '',
  customStyle = '',
  ...props
}: AccordionProps) => {
  return (
    <StyledAccordion
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      {...props}
    >
      <ReactAccordion
        allowZeroExpanded
        allowMultipleExpanded={isAllowedMultipleExpanded}
        onChange={onChangeItem}
        preExpanded={preExpandedList}
      >
        {items.map(({ id, title, titleTag, content }, index) => (
          <AccordionItem
            key={id ?? `${title}-${index}`}
            uuid={id}
            title={title}
            titleTag={titleTag}
            content={content}
            handleItemRefExpansion={handleItemRefExpansion}
            componentClassname={componentClassname}
          />
        ))}
      </ReactAccordion>
    </StyledAccordion>
  );
};

Accordion.displayName = 'Accordion';
export default Accordion;
